import React from 'react';
import { CoursesModalVideoContainer, CoursesVideoContainer } from 'organisms/courses/courses.video.styles'
import Heading from 'elements/typography/heading'
import ModalVideo from 'elements/video/modal.video'
import { FeatureListButtonContainer } from 'organisms/featureList/featureList.list.styles'
import LinkBranded from 'elements/links/Link.branded'
import LinkSimple from 'elements/links/Link.simple'
import { ButtonContentfulModel } from 'src/api/models/Button'
import Paragraph from 'src/elements/typography/paragraph';

export interface CoursesVideoProps {
  title: string;
  description: string;
  modalVideoButton: ButtonContentfulModel;
  actionButtons?: ButtonContentfulModel[];
}

const CoursesVideo = ({
  actionButtons,
  title,
  description,
  modalVideoButton
}: CoursesVideoProps): JSX.Element => {
  return (
    <CoursesVideoContainer>
      <Heading
        align="center"
        size="2.5em"
        sizeLg="2em"
        sizeSubLg="1.5em"
        text={title}
      />
      <Paragraph
        align="center"
        size="1.375em"
        sizeSubLg="1.1875em"
        text={description}
        weight="light"
      />
      <CoursesModalVideoContainer>
        <ModalVideo
          thumbnail={modalVideoButton.thumbnail.gatsbyImageData}
          videoUrl={modalVideoButton.video.file.url}
        />
      </CoursesModalVideoContainer>
      {
        actionButtons?.length ?
          <FeatureListButtonContainer>
            {
              actionButtons.map((button) => {
                if (button.variant.includes('primary')) {
                  return <LinkBranded url={button.url} key={button.id} text={button.text} caption={button.helpText} justify="center" captionJustify="center" weight="bold" />
                } else {
                  return <LinkSimple url={button.url} color="main" key={button.id} text={button.text} iconPosition="right" justify="center" icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.66 15.8" height="11px"><path d="M18.84,8.26A24.57,24.57,0,0,1,15,5.14,11.73,11.73,0,0,1,13.45,1.6l-2.9.8a15,15,0,0,0,2.17,4.65,11.65,11.65,0,0,0,.93,1H0v3H13.65a11.65,11.65,0,0,0-.93.95,15,15,0,0,0-2.17,4.65l2.9.8A12,12,0,0,1,15,13.86a24.73,24.73,0,0,1,3.82-3.12L20.66,9.5Z" transform="translate(0 -1.6)"></path></svg>} />
                }
              })
            }
          </FeatureListButtonContainer>
          : null
      }
    </CoursesVideoContainer>
  );
};

export default CoursesVideo;
